export default __webpack_public_path__ + "media/zurb/img/playground/speed-and-accuracy-hotspot-0c1a76fd6266fc532257ec82971f659d.svg";